const state = {
  entryUrl: "",
  clientHeight: 0
};

const mutations = {
  setEntryUrl(state, value) {
    state.entryUrl = value;
  },
  setClientHeight(state, value) {
    state.clientHeight = value;
  }
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
